import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { Message } from '@/schemas/chat'

interface MessageBubbleProps {
  message: Message
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === 'user'

  const time = new Date(message.created_at).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })

  if (isUser) {
    return (
      <div className="flex justify-end">
        <div className="max-w-[70%]">
          <div className="rounded-2xl rounded-br-md bg-indigo-500/20 border border-indigo-500/30 px-4 py-3">
            <p className="text-sm text-gray-200 whitespace-pre-line">
              {message.content}
            </p>
          </div>
          <p className="mt-1 text-right text-xs text-gray-500">{time}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex justify-start">
      <div className="max-w-[70%]">
        <div className="rounded-2xl rounded-bl-md bg-white/10 px-4 py-3">
          <div className="prose prose-invert prose-sm max-w-none text-gray-200 prose-p:my-1 prose-ul:my-1 prose-ol:my-1 prose-li:my-0.5 prose-pre:bg-black/30 prose-pre:rounded-lg prose-code:text-indigo-300 prose-headings:text-gray-100">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {message.content}
            </ReactMarkdown>
          </div>
        </div>
        <p className="mt-1 text-xs text-gray-500">{time}</p>
      </div>
    </div>
  )
}
